module.exports = __webpack_public_path__ + "static/media/img_2.c0877291.png";